module.exports = __webpack_public_path__ + "img/70.b382c4c0.jpg";